
import { Component, Ref, Prop, Mixins } from "vue-property-decorator";
import { Form } from "element-ui";

import ETable from "@/components/ETable.vue";
import UploadImg from "@/components/uploadImg.vue";
import Resize from "@/mixins/resize";
import { saveMerchantIntelligentType } from "@/api/dialectic";
import { getIntelligentTypeIconUrl } from "@/enum/intelligentType.enum";

@Component({ name: 'dialectic-components-merchantTypeConfig',
    components: { ETable, UploadImg }
})
export default class MerchantTypeConfig extends Mixins(Resize) {
    @Prop({ default: "" }) merchantId !: string;
    @Prop({ default: () => [] }) typeList !: Array<any>;
    @Ref("formRef") formRef !: Form;

    typeColumns = [
        { label: "类型名称", prop: "typeName", minWidth: 150, align: "center" },
        { label: "图标", prop: "icon", width: 120, align: "center" },
        { label: "操作人", prop: "modifiedBy", width: 150, align: "center" },
        { label: "最后操作时间", prop: "modifiedTime", minWidth: 180, align: "center" },
        { label: "操作", prop: "action", fixed: "right", width: 120, align: "center" },
    ];

    dialogVisible = false;
    // README: iconUrl 复用 uploadImg 组件，内部为 [{url}] 数组，保存时取首项 url
    form: { id: number | null; typeName: string; iconUrl: Array<{ url?: string }> } = {
        id: null,
        typeName: "",
        iconUrl: [],
    };

    formRule = {
        typeName: [
            { required: true, message: "请输入类型名称" },
            { validator: (_rule: any, value: string, callback: (err?: Error) => void) => {
                const v = (value || "").trim();
                if (v.length === 0) callback(new Error("请输入类型名称"));
                else if (v.length > 8) callback(new Error("类型名称最多8个字"));
                else callback();
            }, trigger: "blur" },
        ],
        iconUrl: { required: true, message: "图标不可为空" },
    };

    get dialogTitle() {
        return this.form.id ? "编辑" : "新增";
    }

    mounted() {
        // README: 计算表格最大滚动高度，240 为品牌方标题 + tab 头部 + 新增按钮等上方占位的估算值，可按需调整
        this.windowResize(240);
    }

    headerCellStyle() {
        return { background: "#F8F9FA", color: "#1A1A1C", textAlign: "center" };
    }
    cellStyle() {
        return { textAlign: "center" };
    }

    // 图标：个性类目用接口返回的 iconUrl（上传组件已拼好 COS 域名的完整地址），通用类目用前端映射的原图标
    typeIcon(row: any): string {
        return row.customFlag === 1 ? (row.iconUrl || "") : getIntelligentTypeIconUrl(row.typeName);
    }

    handleAdd() {
        this.form = { id: null, typeName: "", iconUrl: [] };
        this.dialogVisible = true;
    }

    handleEdit(row: any) {
        this.form = {
            id: row.id,
            typeName: row.typeName,
            iconUrl: row.iconUrl ? [{ url: row.iconUrl }] : [],
        };
        this.dialogVisible = true;
    }

    dialogClose() {
        this.dialogVisible = false;
        this.formRef?.resetFields();
    }

    dialogSave() {
        this.formRef?.validate().then(() => {
            // NOTE: 图标上传后为 [{url}] 结构，取首项 url 作为 iconUrl 地址
            const iconUrl = this.form.iconUrl[0]?.url || "";
            saveMerchantIntelligentType({
                id: this.form.id || null,
                merchantId: this.merchantId,
                typeName: this.form.typeName.trim(),
                iconUrl,
            }).then(() => {
                this.$message.success("操作成功");
                this.dialogClose();
                this.$emit("refresh");
            });
        }).catch(() => {
            // NOTE: 校验未通过，不提交
        });
    }
}
